const WebhookType = {
  SYSTEM_EVENT: 'System Event',
  CUSTOM_EVENT: 'Custom Event',
  COMMUNICATION: 'Communication',
  JOURNEY: 'Journey',
};

export default WebhookType;
